import styled from 'styled-components';

export const StateContainer = styled.div`
  margin-bottom: 1.5rem;
  grid-template-columns: repeat(2, 1fr);
  display: grid;
  gap: 0.5rem;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const ContentWrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.media.md}) {
    width: 34.5rem;
  }
`;
